import { styled } from '@/styled-system/jsx'

export const StyledToast = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '1rem',
    padding: '10px',
  },
})
